import React, {Fragment} from 'react';

export const ListingTitle = ({title}) => (
  <Fragment>
    <h6 className="m-0"><strong>
      {title}
    </strong></h6>
    <hr className="mt-2"/>
  </Fragment>
);






